import { observer } from 'mobx-react-lite';
import React from 'react';
import Spinner from "components/shared/Spinner";

import {
  AudioStatus,
  AudioToggle,
  Container,
  LaneTextItem,
  LeftLaneContent,
  RightLaneContent,
  Row,
} from './Styles';

export const LaneContentDisconnected = observer(({ item, onClick, key, loading }) => {
  return (
    <Row>
      <AudioToggle disabled={true} laneActive={false}>
      </AudioToggle>
      <Container
        disabled={false}
        key={`Lane_${key}`}
        onClick={loading ? null : onClick}
      >
          {loading ? <div style={{alignItems: 'center', width:'100%', textAlign: 'center', justifyContent: 'center'}}><Spinner /></div> :
        <LeftLaneContent>
          <LaneTextItem>{item.lane}</LaneTextItem>
            <LaneTextItem>-</LaneTextItem>
          <LaneTextItem color="var(--activeLaneTextColor)">
            Not Connected
          </LaneTextItem>
        </LeftLaneContent>}
      </Container>
    </Row>
  );
});

export default LaneContentDisconnected;
